export default import.meta.ROLLDOWN_FILE_URL_rHS4UCiJ0eFSW8ru4CFNMg